import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TotemService } from '../totem.service';
import { Tienda } from '../tiendas/tienda';
import { Categoria } from '../tiendas/categoria';
import { Location } from '@angular/common';
import * as moment from 'moment';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-tienda-selec',
  templateUrl: './tienda-selec.component.html',
  styleUrls: ['./tienda-selec.component.css']
})
export class TiendaSelecComponent implements OnInit {
  id;
  tiporuta;
  tiendas: Array<Tienda>;
  datostienda = null;
  categoriatienda;
  plano;
  hayoferta = false;
  listaofertas = [];
  ofertaactual;
  hayimagen = false;
  displayModal = false;
  tiendaruta;
  tiendasel;
  zoomactivo = true;
  rutaalt = false;
  rutaenviar = environment.tipoTransporte.pie;
  ofertaTienda;

  planos: Array<any>;

  constructor(
    private totemService: TotemService,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  async ngOnInit() {

    await this.totemService.getTotemConfig();
    // logica pra los planos
    this.planos = await this.totemService.getPlanos().toPromise();
    for (const plano of this.planos) {
      const numero = plano.piso_numero;
      if (numero > 0 ) {
      plano.nombre = 'N' + String(numero);
      } else {
        const piso = numero.toString()[1];
        plano.nombre = 'S' + piso;
      } if (numero == 0) {
        const piso = numero.toString()[1];
        plano.nombre = 'N0' ;
      }


      
    }

    this.tiporuta = this.route.snapshot.paramMap.get('tipo');
    try {
      this.id = this.route.snapshot.paramMap.get('id');
      this.tiporuta = this.route.snapshot.paramMap.get('tipo');

      const tiendas = await this.totemService.getTiendas().toPromise();
      this.tiendas = tiendas.map((tienda: any) => new Tienda(tienda));
      for (const tienda of tiendas) {
        this.id = parseInt(this.id, 10);
        this.tiendasel = this.id;
        if (tienda.punto_interes === this.id) {
          this.datostienda = tienda;
        }
      }
      this.tiendaruta = this.datostienda.punto_interes;
      const items = await this.totemService.getCategorias().toPromise();
      const categorias = items.map(item => new Categoria(item));
      for (const cate of categorias) {
        if (cate.id === this.datostienda.categoria) {
          const nombre = cate.nombre.toLowerCase();
          cate.nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
          this.categoriatienda = cate;
        }
      }
      this.totemService.geteventos().subscribe(eventos => {
        for (const evento of eventos) {
          if (evento.punto_interes === this.id) {
            if (evento.tipo_evento === 'Oferta' && evento.publicado === 1) {
              if (moment().isBetween(evento.dia_inicio, evento.dia_termino)) {
                if (!evento.descuento || evento.descuento === null || evento.descuento === '0') {
                  evento.haydescuento = false;
                } else {
                  evento.haydescuento = true;
                }
                this.ofertaTienda = evento;
              }
            }
          }
        }

        this.hayoferta = this.ofertaTienda ? true : false;
        console.log('hay oferta', this.hayoferta, this.ofertaTienda);
      });


    } catch (err) {
      console.error(err);
    }
  }

  public openModal() {
    this.cancelartimer();
    this.displayModal = true;
  }

  public onCloseHandled() {
    this.cancelartimer();
    this.displayModal = false;
  }

  public goBack() {
    this.location.back();
  }
  hacerzoom() {
    this.cancelartimer();
    this.zoomactivo = !this.zoomactivo;
  }
  public iconoruta() {
    if (this.rutaenviar === environment.tipoTransporte.pie) {
      this.rutaenviar = environment.tipoTransporte.alternativo;
    } else {
      this.rutaenviar = environment.tipoTransporte.pie;
    }
    console.log('cambio ruta', this.rutaenviar);
    this.cancelartimer();
    this.rutaalt = !this.rutaalt;
  }
  // logica de reinicio
  scrollevent = (event: any): void => {
    console.log('scroll');
    this.cancelartimer();
  }

  public cancelartimer() {
    this.totemService.emitirReinicioTotem();
  }
}
